import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { CloudImage } from '@components/CloudImage';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { Columns } from '@components/Columns';

export const StreamlineCommunicationWrapper = styled(Box)`
  width: 100%;
  height: 1082px;
`;

export const TextPairBox = styled(Box)`
  width: 100%;
`;

export const StreamlineCommunicationTextPairing = styled(TextPairing)`
  .text-pairing-title {
    font-size: 56px;
    line-height: 68px;
    max-width: 630px;
  }

  .text-pairing-body {
    width: 629px;
  }

  ${themeMediaQuery('below_sm')} {
    width: 100%;

    .text-pairing-title {
      font-size: 40px;
      line-height: 46.88px;
    }

    .text-pairing-body {
      width: 100%;
    }
  }
`;

export const BgImage = styled(CloudImage)`
  object-fit: contain;
  max-height: 466px;
  width: 862px;
  margin-top: 40px;

  @media (min-width: 500px) and (max-width: 833px) {
    max-height: unset !important;
    max-width: 500px !important;
  }
  ${themeMediaQuery('below_sm')} {
    max-height: 168.13px;
    max-width: 311px;
    margin-top: 100px;
  }
`;

export const StyledTextColumn = styled(Columns)``;
